import SideBarTabs from './SideBarTabs';

export default SideBarTabs;
